import { useState, useEffect, useMemo } from "react";
import axios from "axios"

import HeaderTools from "../../../../Components/ComponentsIndustry/HeaderTools";
import SubHeaderPurchase from "../../../../Components/ComponentsIndustry/SubHeaderPurchase";
import ProviderCard from "../../../../Components/ComponentsIndustry/ProviderCard";
import FooterButton from "../../../../Components/ComponentsIndustry/FooterButton";
import CountFooter from "../../../../Components/ComponentsIndustry/CountFooter";
import { Supplier } from "../../../../Supplier/Supplier";
import { useRawMaterial } from "../../../../providers/RawMaterialContext";
import { useValue } from "../../../../providers/ValueContext";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

import { Container, SizeContainer, TitleContent } from "./style";
import { useUser } from "../../../../providers/UserContext";
import { useSupplier } from "../../../../providers/Supplier";

const ToolsPurchasePig = () => {
  const { insumoPernil, setInsumoPernil, getStockInsumo } = useRawMaterial();
  const [message, setMessage] = useState('')
  const {
    outputValue,
    setOutputValue,
    outputValueThirty,
    setOutputValueThirty,
    outputValueSixty,
    setOutputValueSixty,
    entranceValue
  } = useValue();

  const { user, rodada, industry, jogo } = useUser();
  const { totalAmountFornecedorA, totalAmountFornecedorB, totalAmountFornecedorC } = useSupplier()
  const history = new useHistory();

  let [idProvider, setIdProvider] = useState(0)

  let [providerA, setProviderA] = useState(false);
  let [inCashA, setInCashA] = useState(false);
  let [thirtyDaysA, setThirtyDaysA] = useState(false);
  let [totalA, setTotalA] = useState(0);
  let [amountA, setAmountA] = useState(0);

  let [providerB, setProviderB] = useState(false);
  let [inCashB, setInCashB] = useState(false);
  let [thirtyDaysB, setThirtyDaysB] = useState(false);
  let [sixtyDaysB, setSixtyDaysB] = useState(false);
  let [totalB, setTotalB] = useState(0);
  let [amountB, setAmountB] = useState(0);

  let [providerC, setProviderC] = useState(false);
  let [inCashC, setInCashC] = useState(false);
  let [thirtyDaysC, setThirtyDaysC] = useState(false);
  let [sixtyDaysC, setSixtyDaysC] = useState(false);
  let [totalC, setTotalC] = useState(0);
  let [amountC, setAmountC] = useState(0);

  const [sales, setSales] = useState(0);
  const [prodPlanning, setProdPlanning] = useState(0);

  const totalAmount = useMemo(() => {
    return Number(Number(totalAmountFornecedorA) + Number(totalAmountFornecedorB) + Number(totalAmountFornecedorC))
  }, [totalAmountFornecedorA, totalAmountFornecedorB, totalAmountFornecedorC])

  function pagamento(data) {

    if (entranceValue > Number(data.total)) {

      axios.post("https://sistemas.sisinfor.com.br/BusinessGameBack/api/compra/cadastrar", data)
        .then(response => {
          if (response.data?.sucesso) {
            alert("Compra efetuada!")
            axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/estoqueInsumo/obterEstoqueIndustria/4/${industry?.industria}`)
              .then(responseEstoque => {
                var dateUpdated = insumoPernil
                dateUpdated.estoqueInicial = responseEstoque.data?.quantidade
                setInsumoPernil(dateUpdated)
              })
          } else {
            alert("Compra não pôde ser efetuada. " + response.data?.mensagem)
          }

        })
        .catch(error => console.log(error))
    } else {
      alert("Saldo Insuficiente")
    }

  }

  const handlePay = () => {

    const data = {
      "fornecedor": {
        "fornecedor": idProvider
      },
      "industria": industry,
      "insumo": {
        "insumo": 4,
      },
      "pagamento": "",
      "preco": 0,
      "quantidade": 0,
      "rodada": rodada,
      "total": 0
    }


    if (providerA === true) {
      data.quantidade = parseFloat(amountA) * Number(Supplier[0].pernil.fornecedorA.confiabilidade.replace("%", "")) / 100
      data.preco = 12;
      data.total = parseFloat(totalAmountFornecedorA);
      if (inCashA === true) {
        data.pagamento = "avista";
        pagamento(data)
        setOutputValue(outputValue + totalAmountFornecedorA);
      } else {
        data.pagamento = "30dias"
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalAmountFornecedorA + (totalAmountFornecedorA * 5) / 100));
      }
    }

    if (providerB === true) {
      data.quantidade = parseFloat(amountB) * Number(Supplier[0].pernil.fornecedorB.confiabilidade.replace("%", "")) / 100
      data.preco = 12;
      data.total = parseFloat(totalAmountFornecedorB);
      if (inCashB === true) {
        data.pagamento = "avista"
        pagamento(data)
        setOutputValue(outputValue + (totalAmountFornecedorB + (totalAmountFornecedorB * 2) / 100));
      } else if (thirtyDaysB === true) {
        data.pagamento = "30dias"
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalAmountFornecedorB + (totalAmountFornecedorB * 5) / 100));
      } else {
        data.pagamento = "60dias"
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalAmountFornecedorB + (totalAmountFornecedorB * 10) / 100));
      }
    }

    if (providerC === true) {
      data.quantidade = parseFloat(amountC) * Number(Supplier[0].pernil.fornecedorC.confiabilidade.replace("%", "")) / 100
      data.preco = 12;
      data.total = parseFloat(totalAmountFornecedorC);
      if (inCashC === true) {
        data.pagamento = "avista"
        pagamento(data)
        setOutputValue(outputValue + totalAmountFornecedorC);
      } else if (thirtyDaysC === true) {
        data.pagamento = "30dias"
        pagamento(data)
        setOutputValueThirty(outputValueThirty + (totalAmountFornecedorC + (totalAmountFornecedorC * 5) / 100));
      } else {
        data.pagamento = "60dias"
        pagamento(data)
        setOutputValueSixty(outputValueSixty + (totalAmountFornecedorC + (totalAmountFornecedorC * 10) / 100));
      }
    }

    setInsumoPernil({
      estoqueInicial: insumoPernil.estoqueInicial,
      precoMedio: insumoPernil.precoMedio,
      cobertura: insumoPernil.cobertura,
      totalCompra: totalAmountFornecedorA + totalAmountFornecedorB + totalAmountFornecedorC,
      prevVenda: insumoPernil.prevVenda,
      quantidadeCompra:
        parseFloat(amountA) + parseFloat(amountB) + parseFloat(amountC),
    });

  };

  useEffect(() => {

    if (user && rodada) {

      getStockInsumo()

      if (!industry.linguica) {
        if (industry.corteFrango) {
          history.push("/toolsPurchaseChickenLight")
        }
        else if (industry.frangoCarcaca) {
          history.push("/toolsPurchaseChickenHeavy")
        } else if (industry.batata) {
          history.push("/toolsPurchaseFries")
        }
      }

      axios.get(`https://sistemas.sisinfor.com.br/BusinessGameBack/api/pcp/obterInsumo/${4}/${industry?.industria}/${rodada.rodada}`)
        .then(response => {
          // const data = response.data[0]
          setInsumoPernil({
            estoqueInicial: insumoPernil.estoqueInicial,
            precoMedio: insumoPernil.precoMedio,
            cobertura: insumoPernil.cobertura,
            totalCompra: insumoPernil.totalCompra,
            prevVenda: insumoPernil.prevVenda,
            prevProducao: response.data.producao ? response.data.producao : 0,
            quantidadeCompra: insumoPernil.quantidadeCompra,
          })

        })

    }

  }, [user, rodada])

  return (
    <Container>
      <SizeContainer>
        <HeaderTools
          pathImg="./images/purchase_button.svg"
          title="Compras"
          subTitle="(Insumos e Fornecedores)"
          style={["", "selection", "", "", ""]}
        />
        <SubHeaderPurchase
          style={["selection", "", "", "", "", "", ""]}
          product="Pernil Suíno"
          initialStock={insumoPernil.estoqueInicial}
          setMessage={setMessage}
          averagePrice={insumoPernil.estoqueInicial * insumoPernil.precoMedio}
          productionPlanning={insumoPernil.prevProducao}
          roof={insumoPernil.cobertura}
          sales={sales}
          setSales={setSales}
          prodPlanning={insumoPernil.prevProducao}
          setProdPlanning={setProdPlanning}
        />

        <TitleContent>
          <div />
          Fornecedores de <span>Pernil Suíno</span>
        </TitleContent>
        <ProviderCard
          setIdProvider={setIdProvider}
          Supplier={Supplier[0].pernil}
          title1="Fornecedor A"
          minQuant1={Supplier[0].pernil.fornecedorA.minQuant}
          precoBase1={Supplier[0].pernil.fornecedorA.precoBase}
          leadTime1={Supplier[0].pernil.fornecedorA.leadTime}
          atraso1={Supplier[0].pernil.fornecedorA.atraso}
          confiabilidade1={Supplier[0].pernil.fornecedorA.confiabilidade}
          desconto1={Supplier[0].pernil.fornecedorA.desconto}
          provider1={providerA}
          setProvider1={setProviderA}
          inCash1={inCashA}
          setInCash1={setInCashA}
          thirtyDays1={thirtyDaysA}
          setThirtyDays1={setThirtyDaysA}
          total1={totalA}
          setTotal1={setTotalA}
          amount1={amountA}
          setAmount1={setAmountA}
          title2="Fornecedor B"
          minQuant2={Supplier[0].pernil.fornecedorB.minQuant}
          precoBase2={Supplier[0].pernil.fornecedorB.precoBase}
          leadTime2={Supplier[0].pernil.fornecedorB.leadTime}
          atraso2={Supplier[0].pernil.fornecedorB.atraso}
          confiabilidade2={Supplier[0].pernil.fornecedorB.confiabilidade}
          desconto2={Supplier[0].pernil.fornecedorB.desconto}
          provider2={providerB}
          setProvider2={setProviderB}
          inCash2={inCashB}
          setInCash2={setInCashB}
          thirtyDays2={thirtyDaysB}
          setThirtyDays2={setThirtyDaysB}
          sixtyDays2={sixtyDaysB}
          setSixtyDays2={setSixtyDaysB}
          total2={totalB}
          setTotal2={setTotalB}
          amount2={amountB}
          setAmount2={setAmountB}
          title3="Fornecedor C"
          minQuant3={Supplier[0].pernil.fornecedorC.minQuant}
          precoBase3={Supplier[0].pernil.fornecedorC.precoBase}
          leadTime3={Supplier[0].pernil.fornecedorC.leadTime}
          atraso3={Supplier[0].pernil.fornecedorC.atraso}
          confiabilidade3={Supplier[0].pernil.fornecedorC.confiabilidade}
          desconto3={Supplier[0].pernil.fornecedorC.desconto}
          provider3={providerC}
          setProvider3={setProviderC}
          inCash3={inCashC}
          setInCash3={setInCashC}
          thirtyDays3={thirtyDaysC}
          setThirtyDays3={setThirtyDaysC}
          sixtyDays3={sixtyDaysC}
          setSixtyDays3={setSixtyDaysC}
          total3={totalC}
          setTotal3={setTotalC}
          amount3={amountC}
          setAmount3={setAmountC}
        />
        <CountFooter total={totalAmount} />
        <FooterButton
          text="Confirmar"
          // path={"/toolsPurchaseChickenLight"}
          onHandle={handlePay}
        />
      </SizeContainer>
    </Container>
  );
};
export default ToolsPurchasePig;
